/**
 * 결과 그리드 — 셀 범위 선택과 복사(2026-10-07, 사용자 요청 「여러 셀 선택 + Ctrl+C」).
 *
 * 복사 형식은 **탭 구분(TSV)** 이다 — 엑셀·구글 시트·대부분의 편집기가 붙여넣을 때 칸으로 읽는 형식이다.
 * 값 안에 탭·줄바꿈·큰따옴표가 있으면 그 칸을 큰따옴표로 감싸고 안의 큰따옴표는 두 번 쓴다(엑셀 규칙) —
 * 안 그러면 줄바꿈이 든 값 하나가 붙여넣는 곳에서 행을 쪼갠다.
 */

/** 선택(앵커·포커스)을 정규화한 사각형 */
export function selectionRect(sel) {
  if (!sel || !sel.a || !sel.f) return null;
  return {
    r0: Math.min(sel.a.r, sel.f.r), r1: Math.max(sel.a.r, sel.f.r),
    c0: Math.min(sel.a.c, sel.f.c), c1: Math.max(sel.a.c, sel.f.c),
  };
}

export function inRect(rect, r, c) {
  return !!rect && r >= rect.r0 && r <= rect.r1 && c >= rect.c0 && c <= rect.c1;
}

function tsvCell(text) {
  const s = String(text);
  return /[\t\r\n"]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
}

/**
 * @param {Array<Object>} rows      화면 순서의 행 원본 객체
 * @param {string[]} colIds         화면 순서의 데이터 열 id
 * @param {{r0,r1,c0,c1}} rect
 * @param {(value) => string} toText 값 → 글자(NULL 은 빈 칸으로)
 * @param {{ withHeader?: boolean }} [opts]
 */
export function rangeToTsv(rows, colIds, rect, toText, opts = {}) {
  if (!rect) return '';
  const cols = colIds.slice(rect.c0, rect.c1 + 1);
  const out = [];
  if (opts.withHeader) out.push(cols.map(tsvCell).join('\t'));
  for (let r = rect.r0; r <= rect.r1; r += 1) {
    const row = rows[r];
    if (!row) continue;
    out.push(cols.map(id => tsvCell(toText(row[id]))).join('\t'));
  }
  return out.join('\n');
}

/**
 * 클립보드에 쓴다. 보안 컨텍스트가 아니면(http) navigator.clipboard 가 없어서 숨긴 textarea 로 되돌아간다.
 * @returns {Promise<boolean>}
 */
export async function writeClipboard(text) {
  try {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(text);
      return true;
    }
  } catch (_e) { /* 아래 방법으로 */ }
  try {
    const ta = document.createElement('textarea');
    ta.value = text;
    ta.setAttribute('readonly', '');
    ta.style.position = 'fixed';
    ta.style.left = '-9999px';
    document.body.appendChild(ta);
    ta.select();
    const ok = document.execCommand('copy');
    document.body.removeChild(ta);
    return ok;
  } catch (_e) {
    return false;
  }
}
